<template>
 <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >在线文档</span>
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >测试工具</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
 import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";


import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'threeCode/getThreeSegmentCode';
export default {
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: "通过地址查询对应的三段码信息",
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: "接入方在平台的api账户标识"},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: "签名字符串"},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: "时间戳，毫秒"}
                    ]
            },
             { 
                title:'请求参数', 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
            {
              title:"业务参数",
              value:[
                {name: "sender",type: "Object",require: "N",normal: "",describe: "寄件信息对象(填写后则内部参数必须按要求填写）"},
                {name: "receiver",type: "Object",require: "Y",normal: "",describe:"收件信息对象"}
              ]
            },
            {
              title:"sender类型说明",
              value:[
                {name: "countryCode",type: "String(20)",require: "Y",normal: "",describe: "寄件国家三字码（如：中国=CHN、印尼=IDN）"},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe:"寄件省份"},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe:"寄件城市"},
                {name: "area",type: "String(32)",require: "Y",normal: "",describe:"寄件区域"},
                {name: "town",type: "String(32)",require: "N",normal: "",describe:"寄件乡镇"},
                {name: "street",type: "String(32)",require: "N",normal: "",describe:"寄件街道"},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe:"寄件详细地址（省+市+区县+详细地址）"}
              ]
            },
            {
              title:"receiver类型说明",
              value:[
                {name: "countryCode",type: "String(20)",require: "Y",normal: "",describe: "收件国家三字码（如：中国=CHN、印尼=IDN）"},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe:"收件省份"},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe:"收件城市"},
                {name: "area",type: "String(32)",require: "Y",normal: "",describe:"收件区域"},
                {name: "town",type: "String(32)",require: "N",normal: "",describe:"收件乡镇"},
                {name: "street",type: "String(32)",require: "N",normal: "",describe:"收件街道"},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe:"收件详细地址（省+市+区县+详细地址）"}
              ]
            },

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:'响应参数',
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: "返回码，见附录",},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: "描述",},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: "业务数据",},
                  ]
            },
            {
              title:"data类型说明",
              value:[
                  {name: "lastCenterName",type: "String",require: "N",normal: "",describe: "集包地"},
                  {name: "sortingCode",type: "String",require: "Y",normal: "",describe: "三段码（获取到三段码优先返回三段码，无三段码返回大头笔）"}
                ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1001
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent={
      "sender":{
        "name":"abc",
        "mobile":"023-233929",
        "phone":"1352332333",
        "countryCode":"CHN",
        "prov":"江苏省",
        "city":"南京市",
        "area":"玄武区",
        "address":"江苏省南京市玄武区珠江路455号"
        },
      "receiver":{
        "name":"abc",
        "mobile":"023-233929",
        "phone":"1352332333",
        "countryCode":"CHN",
        "prov":"江苏省",
        "city":"南京市",
        "area":"玄武区",
        "address":"江苏省南京市玄武区珠江路455号"
      }
    }`,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "success",
    "data": {
        "lastCenterName": "南京玄武集散点",
        "sortingCode": "320  800-05  000"
    }
}`),

        //错误代码提示
        errcodeJson: [{code:"145003083",msg:"始发地信息不全"},{code:"145003084",msg:"收货地信息不全"}]
      },

      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{"sender":{"name":"abc","mobile":"023-233929","phone":"1352332333","countryCode":"CHN","prov":"江苏省","city":"南京市","area":"玄武区","address":"江苏省南京市玄武区珠江路455号"},"receiver":{"name":"abc","mobile":"023-233929","phone":"1352332333","countryCode":"CHN","prov":"江苏省","city":"南京市","area":"玄武区","address":"江苏省南京市玄武区珠江路455号"}}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: [{code:"145003083",msg:"始发地信息不全"},{code:"145003084",msg:"收货地信息不全"}]
      },
    };
  },
 created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
 }
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>